(ns lupapalvelu.ui2.topbar
  "Reusable top bar component. Props-driven, no global state.

  [topbar {:user        {:name \"Pena Panaani\" :org-name \"Jyväskylä\"}
           :apps        [{:label \"Dokumentit\" :icon icons/archive :href \"...\"}]
           :on-logout   my-logout-fn
           :user-items  [{:label \"Omat tiedot\" :icon icons/user :href \"...\"}]}]"
  (:require [lupapalvelu.ui.common :refer [loc]]
            [lupapalvelu.ui2.dropdown :refer [dropdown-menu]]
            [lupapalvelu.ui2.icons :as icons]
            [lupapalvelu.ui2.variant-builder :refer [builder merge-props-classes]]))

(def classes
  (builder
    {:base     {:root        ["twp"
                              "nobase"
                              "lp-theme"
                              "flex" "items-center"
                              "bg-header-fill" "text-white"
                              ;; FIXME: No variable for the border on Figma
                              "border-b" "border-[#82C1C9]/20"
                              "fixed" "top-0" "left-0" "right-0"
                              "z-[var(--ui2-z-topbar)]"
                              "h-[var(--topbar-height)]"]
                :inner       ["mx-auto" "w-full"
                              "px-4" "sm:px-6" "lg:px-8"
                              "h-full"
                              "flex" "items-center" "justify-between"]
                :user-avatar ["w-6" "h-6"
                              "bg-white" "rounded-full"
                              "flex" "items-center" "justify-center"
                              "shrink-0"]}
     :variants {}}))

(defn topbar
  "Props:
    :logo-src       – src for the logo image (default \"/lp-static/img/lupapiste-logo.svg\")
    :logo-href      – href for the logo link (optional; preferred for pure navigation)
    :on-logo-click  – fn (optional)
    :user           – {:name \"...\" :org-name \"...\" :role \"...\"}
    :apps           – seq of {:key (required) :label :icon :href :on-click :disabled? :separator-before?}
    :apps-label            – label for apps trigger button and dropdown header title
    :apps-subtitle         – subtitle shown in the apps dropdown header
    :user-items     – same shape as apps (with :key required)
    :on-logout      – fn
    :logout-label   – label for the logout item (default: (loc \"logout\"))
    :aria-label     – overrides \"Päänavigaatio\"
    :classes        - {:root \"...\"}

  Note: the interface uses separate named props (:apps, :user-items, :on-logout etc.) rather than
  a single generic :items vector. This keeps the caller's intent explicit and avoids leaking
  Lupapiste-specific concepts (app switcher vs. user menu) into a single opaque list.
  The trade-off is a slightly wider prop surface, which is acceptable as this component is
  only used in one place (topbar-connected)."
  [{:keys [logo-src logo-href on-logo-click user language language-items apps apps-label apps-subtitle user-items on-logout logout-label aria-label] :as props}]
  (let [user-name       (:name user)
        user-role       (or (:role user) (:org-name user))
        apps-btn-label  (or apps-label (loc "topbar.apps.title"))
        apps-hdr-sub    (or apps-subtitle (loc "topbar.apps.subtitle"))
        logo-props      (merge {:class      "flex items-center bg-transparent border-0 p-0 cursor-pointer"
                                :aria-label "Lupapiste"}
                               (if logo-href
                                 {:href logo-href}
                                 {:type     "button"
                                  :on-click on-logo-click}))
        full-user-items (into (vec user-items)
                              [{:key      "logout"
                                :label    (or logout-label (loc "logout"))
                                :icon     icons/logout
                                :on-click on-logout}])]
    [:nav (merge-props-classes {:aria-label (or aria-label (loc "topbar.nav.aria-label"))
                                :class      (:root (:classes props))}
                               (classes {} :root))
     [:div (merge-props-classes {} (classes {} :inner))
      ;; Logo
      [(if logo-href :a :button) logo-props
       [:img {:src   (or logo-src "/lp-static/img/lupapiste-logo.svg")
              :alt   "Lupapiste"
              :class "h-[35px] brightness-0 invert"}]]

      ;; Right-side controls
      [:div.flex.items-center.gap-3
       (when (seq language-items)
         [dropdown-menu {:aria-label      (loc "userinfo.language")
                         :theme           :dark
                         :trigger-content [:<>
                                           [:span language]
                                           [icons/chevron-down {:size 16 :aria-hidden "true"}]]
                         :items           language-items}])
       (when (seq apps)
         [dropdown-menu {:aria-label      apps-btn-label
                         :align           :left
                         :theme           :dark
                         :header          {:title    apps-btn-label
                                           :subtitle apps-hdr-sub}
                         :trigger-content [:<>
                                           [icons/apps {:size 16 :aria-hidden "true"}]
                                           [:span apps-btn-label]
                                           [icons/chevron-down {:size 16 :aria-hidden "true"}]]
                         :items           apps}])
       (when user-name
         [dropdown-menu {:aria-label      user-name
                         :theme           :dark
                         :header          {:title    user-name
                                           :subtitle user-role}
                         :trigger-content [:<>
                                           [:div (merge-props-classes {} (classes {} :user-avatar))
                                            [icons/user {:size        16
                                                         :aria-hidden "true"
                                                         :class       "text-text-lightbg"}]]
                                           [:span user-name]
                                           [icons/chevron-down {:size 16 :aria-hidden "true"}]]
                         :items           full-user-items}])]]]))
